var map = {
	"./Contact.svg": 8962,
	"./Technica-Service.svg": 2398,
	"./about.svg": 8406,
	"./back.svg": 8580,
	"./close.svg": 4122,
	"./home.svg": 3452,
	"./join-us.svg": 8897,
	"./left.svg": 5935,
	"./logo.svg": 5771,
	"./menu.svg": 118,
	"./right.svg": 4848
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3007;